import { render, staticRenderFns } from "./Func10Historico.vue?vue&type=template&id=4fb689f8"
import script from "./Func10Historico.vue?vue&type=script&lang=js"
export * from "./Func10Historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports